export const ACTIVITY_TYPES = [
  "Ristorante / Trattoria",
  "Bar / Caffetteria",
  "Pizzeria",
  "Laboratorio / Produzione",
  "Catering / Eventi",
  "Hotel / Colazioni",
  "Altro",
];

export const PANIC_SESSION_MODES = [
  {
    id: "operator",
    title: "Operatore",
    subtitle: "Versione classica: l'operatore chiede aiuto a Norma durante il controllo.",
  },
  {
    id: "inspector",
    title: "Ispettore",
    subtitle: "Checklist guidata da mostrare e seguire durante audit simulato o visita.",
  },
];

export const OPERATOR_PANIC_STEPS = [
  {
    id: "intro",
    title: "Ok. Segui me.",
    instruction: "Una cosa alla volta. Mettiamo in ordine cio che conta davvero.",
    priority: 0,
    level: "A",
    modulePath: null,
    moduleLabel: null,
    quickReplyIds: ["sistema_haccp", "responsabile"],
    correctiveType: "generica",
  },
  {
    id: "documenti",
    title: "Documenti",
    instruction: "Apri il piano HACCP. Tienilo pronto.",
    priority: 1,
    level: "C",
    modulePath: "/manuale",
    moduleLabel: "Apri manuale HACCP",
    quickReplyIds: ["sistema_haccp"],
    correctiveType: "documento",
  },
  {
    id: "temperature",
    title: "Temperature",
    instruction: "Apri il registro temperature.",
    priority: 2,
    level: "A",
    modulePath: "/registri?tipo=frighi",
    moduleLabel: "Apri registro temperature",
    quickReplyIds: ["temperature"],
    correctiveType: "temperatura",
    valuePlaceholder: "Es. Frigo carne 4.2 C, freezer -18 C",
  },
  {
    id: "controllo_visivo",
    title: "Controllo visivo",
    instruction: "Controlla le non conformità registrate.",
    priority: 3,
    level: "A",
    modulePath: "/non-conformita",
    moduleLabel: "Apri non conformita",
    quickReplyIds: ["non_conformita"],
    correctiveType: "generica",
  },
  {
    id: "etichette",
    title: "Etichette",
    instruction: "Se non è etichettato, per l'ispettore non esiste.",
    priority: 4,
    level: "A",
    modulePath: "/etichette?tab=storico",
    moduleLabel: "Apri storico etichette",
    quickReplyIds: ["non_conformita"],
    correctiveType: "etichetta",
  },
  {
    id: "allergeni",
    title: "PROCEDURE",
    instruction: "Mostra la procedura, non la memoria. Qui non si improvvisa.",
    priority: 5,
    level: "A",
    modulePath: "/procedure",
    moduleLabel: "Apri procedure",
    quickReplyIds: ["allergeni"],
    correctiveType: "allergeni",
  },
  {
    id: "tracciabilita",
    title: "Tracciabilità",
    instruction: "Recupera ultimo DDT o fattura del fornitore. Ti serve come prova.",
    priority: 6,
    level: "B",
    modulePath: "/archivio-ddt",
    moduleLabel: "Apri archivio DDT",
    quickReplyIds: ["tracciabilita"],
    correctiveType: "generica",
  },
  {
    id: "pulizie",
    title: "Pulizie",
    instruction: "Mostra il registro della sanificazione.",
    priority: 7,
    level: "B",
    modulePath: "/sanificazione/registro",
    moduleLabel: "Apri registro sanificazione",
    quickReplyIds: ["pulizie"],
    correctiveType: "generica",
  },
  {
    id: "chiusura",
    title: "Chiusura",
    instruction: "Ispezione terminata. Registra osservazioni e conferma il responsabile.",
    priority: 8,
    level: "C",
    modulePath: "/allegati-gestione",
    moduleLabel: "Apri allegati",
    quickReplyIds: ["non_conformita", "responsabile"],
    correctiveType: "generica",
  },
];

export const INSPECTOR_PANIC_STEPS = [
  {
    id: "intro",
    title: "Audit simulato pre-ispezione",
    objective: "Impostare subito il controllo guidato e allineare il responsabile presente.",
    instruction: "Una cosa alla volta. Questa area ti aiuta a prepararti a NAS e ASL e a ripetere il controllo ogni 3 mesi.",
    priority: 0,
    level: "A",
    modulePath: null,
    moduleLabel: null,
    quickReplyIds: ["sistema_haccp", "responsabile"],
    correctiveType: "generica",
    checklist: [
      "Conferma chi sta seguendo la verifica in questo momento",
      "Usa il panic mode come audit simulato trimestrale interno",
      "Segna solo prove verificabili, non supposizioni",
    ],
  },
  {
    id: "documenti_amministrativi",
    title: "Documenti amministrativi / autorizzativi",
    objective: "Verificare che l'attivita sia legittimamente esercitata.",
    instruction: "Controlla se tutta la documentazione autorizzativa e reperibile subito.",
    priority: 1,
    level: "C",
    modulePath: "/profilo-azienda",
    moduleLabel: "Apri profilo azienda",
    quickReplyIds: ["sistema_haccp"],
    correctiveType: "documento",
    checklist: [
      "Visura camerale aggiornata",
      "SCIA e notifica sanitaria",
      "Planimetria locali e destinazione d'uso",
      "Autorizzazioni specifiche: dehor, insegne, emissioni se presenti",
    ],
  },
  {
    id: "sistema_haccp",
    title: "Sistema HACCP",
    objective: "Verificare il controllo igienico-sanitario e la tenuta del sistema.",
    instruction: "Apri il manuale e verifica che il sistema HACCP sia aggiornato, coerente e realmente applicato.",
    priority: 2,
    level: "A",
    modulePath: "/manuale",
    moduleLabel: "Apri manuale HACCP",
    quickReplyIds: ["sistema_haccp", "temperature", "pulizie"],
    correctiveType: "documento",
    checklist: [
      "Manuale HACCP aggiornato e personalizzato",
      "Analisi pericoli, CCP, PRP e OPPR",
      "Diagrammi di flusso aggiornati",
      "Registrazioni fondamentali: temperature, pulizie, tracciabilita, non conformita, audit interni",
    ],
  },
  {
    id: "tracciabilita",
    title: "Tracciabilita e rintracciabilita",
    objective: "Ricostruire la filiera in caso di rischio.",
    instruction: "Prepara l'ultima evidenza utile per dimostrare il collegamento tra fornitore, prodotto e utilizzo.",
    priority: 3,
    level: "A",
    moduleLinks: [
      { path: "/archivio-ddt?readonly=1", label: "Storico DDT" },
      { path: "/etichette?tab=storico&readonly=1", label: "Storico etichette" },
    ],
    quickReplyIds: ["tracciabilita"],
    correctiveType: "generica",
    checklist: [
      "DDT o fatture fornitori disponibili",
      "Schede tecniche o evidenze equivalenti quando utili",
      "Etichette originali o foto etichette",
      "Sistema one step back / one step forward se applicato",
    ],
  },
  {
    id: "documenti_sanitari",
    title: "Documenti sanitari / analitici",
    objective: "Verificare la sicurezza ambientale e alimentare.",
    instruction: "Controlla che formazione, analisi e controlli sanitari siano reperibili e aggiornati.",
    priority: 4,
    level: "B",
    modulePath: "/api/documenti_azienda.php?cat=analisi_laboratorio",
    moduleLabel: "Apri analisi laboratorio",
    quickReplyIds: ["documenti", "responsabile"],
    correctiveType: "documento",
    checklist: [
      "Formazione HACCP e registri formazione personale",
      "Analisi acqua dove richieste",
      "Valutazione rischio legionella e piano di controllo se dovuto",
      "Tamponi o analisi superfici se previsti dal piano",
    ],
  },
  {
    id: "corsi_attestati",
    title: "Corsi e attestati dipendenti",
    objective: "Verificare che la formazione del personale sia documentata e pronta da mostrare.",
    instruction: "Apri l'archivio dei corsi e degli attestati del personale HACCP.",
    priority: 5,
    level: "B",
    moduleLinks: [
      { path: "/api/documenti_azienda.php?cat=corso_alimentaristi", label: "Apri certificati e attestati" },
    ],
    quickReplyIds: ["responsabile"],
    correctiveType: "documento",
    checklist: [
      "Attestati alimentaristi disponibili",
      "Formazione HACCP aggiornata per i dipendenti",
      "Coerenza tra personale presente e attestati archiviati",
    ],
  },
  {
    id: "contratti_servizi",
    title: "Contratti obbligatori / servizi esterni",
    objective: "Verificare la gestione dei rischi indiretti.",
    instruction: "Controlla che i servizi esterni critici siano coperti da contratto o evidenze di intervento.",
    priority: 5,
    level: "B",
    moduleLinks: [
      { path: "/infestanti?readonly=1", label: "Storico infestanti" },
      { path: "/manutenzioni?readonly=1", label: "Storico manutenzioni" },
    ],
    quickReplyIds: ["responsabile"],
    correctiveType: "generica",
    checklist: [
      "Derattizzazione e disinfestazione",
      "Smaltimento oli esausti e rifiuti speciali se presenti",
      "Manutenzione frigoriferi, cappe e attrezzature critiche",
      "Lavaggio tessili esternalizzato dove previsto",
    ],
  },
  {
    id: "struttura_locali",
    title: "Struttura e locali",
    objective: "Verificare la conformita strutturale con controllo visivo.",
    instruction: "Fai il giro rapido dei locali e annota subito quello che non e coerente con il piano.",
    priority: 3,
    level: "A",
    modulePath: "/non-conformita?readonly=1",
    moduleLabel: "Storico non conformità",
    quickReplyIds: ["non_conformita"],
    correctiveType: "generica",
    checklist: [
      "Stato manutentivo di pareti, pavimenti e soffitti",
      "Separazione sporco / pulito e flussi di lavorazione",
      "Lavamani e dotazioni igieniche presenti",
      "Sistemi anti-insetti, illuminazione e aerazione",
    ],
  },
  {
    id: "allergeni",
    title: "Gestione allergeni",
    objective: "Tutela del consumatore e prevenzione contaminazioni.",
    instruction: "Qui non si improvvisa: servono evidenze chiare su allergeni, menu e procedure.",
    priority: 7,
    level: "A",
    modulePath: "/procedure",
    moduleLabel: "Apri procedure",
    quickReplyIds: ["allergeni"],
    correctiveType: "allergeni",
    checklist: [
      "Lista allergeni aggiornata",
      "Collegamento allergeni -> piatti o menu",
      "Procedure per contaminazione crociata",
      "Informazione al cliente tramite menu, cartelli o QR",
    ],
  },
  {
    id: "temperature",
    title: "Temperature e registrazioni critiche",
    objective: "Verificare i controlli critici realmente registrati.",
    instruction: "Segna la temperatura reale adesso. Non quella di solito.",
    priority: 8,
    level: "A",
    modulePath: "/registri?readonly=1",
    moduleLabel: "Consulta gli storici",
    quickReplyIds: ["temperature"],
    correctiveType: "temperatura",
    valuePlaceholder: "Es. Frigo carne 4.2 C, freezer -18 C, abbattitore -20 C",
    checklist: [
      "Frigoriferi / freezer",
      "Abbattitori",
      "Cottura se prevista",
      "Coerenza tra registro e stato reale",
    ],
  },
  {
    id: "pulizie",
    title: "Pulizie, rifiuti e igiene operativa",
    objective: "Evitare contaminazioni e verificare i comportamenti reali.",
    instruction: "Servono prove coerenti su pulizie, rifiuti e comportamento del personale.",
    priority: 9,
    level: "B",
    modulePath: "/sanificazione/registro",
    moduleLabel: "Storico sanificazione",
    quickReplyIds: ["pulizie"],
    correctiveType: "generica",
    checklist: [
      "Pulizie e sanificazioni registrate",
      "Gestione rifiuti con contenitori idonei e area dedicata",
      "Igiene operatori e uso DPI",
      "Procedure reali coerenti con il manuale",
    ],
  },
  {
    id: "non_conformita",
    title: "Non conformita e azioni correttive",
    objective: "Valutare capacita di risposta e tracciabilita delle correzioni.",
    instruction: "Se trovi un punto debole, registralo subito e assegna un'azione concreta.",
    priority: 10,
    level: "A",
    modulePath: "/non-conformita?readonly=1",
    moduleLabel: "Storico non conformità",
    quickReplyIds: ["non_conformita", "responsabile"],
    correctiveType: "generica",
    checklist: [
      "Registro non conformita presente",
      "Azioni correttive documentate",
      "Tempo di risposta verificabile",
      "Eventuali evidenze fotografiche o documentali allegate",
    ],
  },
  {
    id: "chiusura",
    title: "Chiusura audit e piano trimestrale",
    objective: "Chiudere la verifica e lasciare una traccia utile per il prossimo controllo.",
    instruction: "Chiudi l'audit, registra osservazioni, responsabile presente e prossimo richiamo trimestrale.",
    priority: 11,
    level: "C",
    modulePath: "/allegati-gestione",
    moduleLabel: "Apri allegati",
    quickReplyIds: ["non_conformita", "responsabile"],
    correctiveType: "generica",
    checklist: [
      "Riepilogo osservazioni ispettive",
      "Responsabile presente e firma interna",
      "Azioni prioritarie da eseguire",
      "Promemoria per audit simulato entro 3 mesi",
    ],
  },
];

export const CORRECTIVE_ACTIONS = {
  temperatura: {
    problemOptions: ["Temperatura fuori range", "Lettura non disponibile", "Frigo sovraccarico"],
    actionOptions: [
      "Sposta prodotti in frigo funzionante",
      "Riduci carico e chiudi porta",
      "Chiama manutenzione",
      "Valuta scarto se catena freddo compromessa",
    ],
    verification: "Ricontrolla temperatura e registra l'esito.",
  },
  etichetta: {
    problemOptions: ["Etichetta mancante", "Data non leggibile", "Lotto non indicato"],
    actionOptions: ["Etichetta subito", "Isola il prodotto", "Rimuovi prodotto non identificabile"],
    verification: "Verifica che data, scadenza e lotto siano leggibili.",
  },
  allergeni: {
    problemOptions: ["Allergeni non chiari", "Tabella non aggiornata", "Rischio contaminazione"],
    actionOptions: ["Mostra tabella allergeni", "Sanifica utensili e superficie", "Blocca preparazione dubbia"],
    verification: "Conferma procedura e separazione dei flussi.",
  },
  documento: {
    problemOptions: ["Documento non reperibile", "Manuale non aggiornato", "Registro mancante"],
    actionOptions: ["Segna NON OK", "Recupera documento con consulente", "Mostra evidenza alternativa se documentata"],
    verification: "Aggiorna e allega la prova appena disponibile.",
  },
  generica: {
    problemOptions: ["Non conformita generica", "Evidenza incompleta", "Procedura non verificabile"],
    actionOptions: ["Isola il rischio", "Registra non conformita", "Applica correzione immediata"],
    verification: "Verifica successiva e firma responsabile.",
  },
};
